import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { applicationSettingsAPI } from "../../services/api";
import { useSnackbar } from "../../contexts/SnackbarContext";

const RegistrationGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isRegistrationAllowed, setIsRegistrationAllowed] = useState(false);
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const checkRegistrationStatus = async () => {
      try {
        const { data } = await applicationSettingsAPI.getRegistrationStatus();
        setIsRegistrationAllowed(data.allowRegistration);
      } catch (error) {
        console.error("Error checking registration status:", error);
        showSnackbar("Unable to verify registration status", "error");
        setIsRegistrationAllowed(false);
      } finally {
        setLoading(false);
      }
    };

    checkRegistrationStatus();
  }, [showSnackbar]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isRegistrationAllowed) {
    showSnackbar("Registration is currently disabled", "error");
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default RegistrationGuard;
